<template>
  <div class="h-full">
      <div v-if="loaded" class="flex flex-row justify-between items-baseline px-4 ">
        <div class="justify-self-start text-2xl col-span-2 font-semibold importantText" >
          {{ total }}
        </div>
        <div>
          <percentage-item :percentage="percentage/100" ></percentage-item>
        </div>
      </div>
    <line-chart  :content="props.source.substring(props.source.lastIndexOf('/')+1)" @changeLoaded="changeLoaded($event)" @setPercentage="setPercentage($event)" :hasLongTitle="props.hasLongTitle" :update="props.update" :source="props.source" :style="props.style" :colorPalette="props.colorPalette" class="pb-6" ></line-chart>
  </div>
</template>



<script setup>
import {defineProps, ref, defineEmits, } from "vue";
import LineChart from "@/widgetContent/charts/LineChart";
import PercentageItem from "@/widgetContent/extras/PercentageItem.vue"
const emit = defineEmits(["dataLoaded", "dataUnloaded"])

const props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})

let percentage = ref();
let total = ref();
let loaded = ref(false);

function setPercentage(e)
{
  percentage.value = e[0]
  total.value = e[1]
  loaded.value = true;
}

function changeLoaded(e){
  if (e){
    emit("dataLoaded")
  }
  else{
    emit("dataUnloaded")
    loaded.value = false;
  }
}
</script>